import { Button, Card, Col, Form, Row } from "react-bootstrap";
import PageTemplate from "../../templates/Pagetemplate";
import BreadCrumb from "../../molecules/BreadCrumb";
import InputFilePreview from "../../molecules/InputFilePreview";
import styled from "styled-components";
import InputAddField from "../../molecules/InputAddField";
import InputGroupValidation from "../../molecules/InputGroupValidation";
import { useForm } from "react-hook-form";
import DataTable from "../../organisms/DataTable";
import MobileAuth from "../../molecules/MobileAuth";
import { useDispatch, useSelector } from "react-redux";
import { hideConfirm, showConfirm } from "../../../../reducer/confirmSlice";
import { Link, useNavigate, useParams } from "react-router-dom";
import { useMutation, useQuery } from "@tanstack/react-query";
import { useEffect, useState } from "react";
import { showAlert } from "../../../../reducer/alertSlice";
import axios from "axios";
import { useRefresh } from "../../../common/hook";
import Loading from "../../organisms/Loading";



const Wrap = styled.div`
    .form-label {
        min-width: 170px;

        & + div[class^=col] {
            flex: 1 1;
        }
    }

    .form-check-label {
        white-space: nowrap;
        font-size: 14px;
    }
`;
export default function DetailCompany(props) {
    const { id } = useParams();
    const [defaultData, setDefaultData] = useState();
    const [time, setTime] = useState(Date.now());
    const [dirty, setDirty] = useState(false);
    const [branchList, setBranchList] = useState([]);
    const loginInfo = useSelector(state => state.login);

    const [companyAdminList, setCompanyAdminList] = useState([]);
    const {
        register,
        handleSubmit,
        setValue,
        watch,
        getValues,
        setError,
        formState: { errors },
    } = useForm({});

    const dispatch = useDispatch();
    const navigate = useNavigate();

    const refresh = useRefresh();


    const removeCompanyAdminList = (value) => {
        setCompanyAdminList(prev => prev.filter(val => value !== val))
    }
    const addCompanyAdminList = (value) => {
        setCompanyAdminList(prev => [...prev, value])
    }

    // 업체 상세
    const detailQuery = useQuery({
        queryKey: ['DetailCompany', id, time],
        refetchOnWindowFocus: false,
        retry: 1,
        queryFn: () => {
            return axios("/company/detail/" + id, {
                method: "GET",
            }).then(result => {
                // 지점 리스트
                const arr = [];
                result.data.data.branch.forEach((el, idx) => {
                    arr.push([result.data.data.branch.length - idx, el.region, el.branchName, el.owner, el.tel, el.registerTime]);
                });
                setBranchList([...branchList, ...arr.reverse()]);

                // 업체 관리자
                const adminArr = [];
                result.data.data.admin.forEach((el, idx) => {
                    adminArr.push(el.phone);
                })
                setCompanyAdminList([...adminArr]);

                if (result.data.data.logoFilePath) {
                    setValue("defaultFile", result.data.data.logoFilePath);
                }

                setDefaultData({
                    companyAdminList: adminArr,
                    logoFile: result.data.data.logoFilePath,
                    companyName: result.data.data.companyName
                });

                return result.data;
            }); 
        },
    });

    // 업체 수정
    const updateCompany = useMutation({
        mutationKey: ['updateCompany'],
        mutationFn: () => {
            const values = getValues();
            if (values.companyAdminList.length == 0) {
                dispatch(showAlert({
                    msg: <>필수 항목이 입력되지 않았습니다.<br/>다시 확인해주세요.</>
                }));
                return false;
            }

            return axios("/company/update/" + id, {
                method: "PUT",
                headers: {
                    "Content-Type": "multipart/form-data",
                },
                data: {
                    companyName: values.companyName,
                    companyAdminList: values.companyAdminList,
                    logoFile: values.logoFile[0]
                }
            }).then(result => {
                if (result.status == 201) {
                    dispatch(showAlert({
                        msg: "수정되었습니다.",
                        func: () => {
                            navigate("/admin/list/company");
                            refresh.refetch();
                        }
                    }))
                } else {
                    dispatch(showAlert({
                        msg: result.data.msg.ko
                    }));
                }
                
                return result.data;
            })
        }
    });

    // 업체 삭제
    const deleteCompany = useMutation({
        mutationKey: ['deleteCompany'],
        mutationFn: () => {
            return axios("/company/delete/" + id, {
                method: "DELETE",
            }).then(result => {
                if (result.status == "204") {
                    dispatch(showAlert({
                        msg: "삭제되었습니다.",
                        func: () => {
                            navigate("/admin/list/company");
                            refresh.refetch();
                        }
                    }))
                    
                } else {
                    dispatch(showAlert({
                        msg: <>삭제 도중 오류가 발생했습니다.<br/>잠시 후 다시 시도해주세요.</>
                    }))
                }

                return result.data;
            });
        }
    });

    useEffect(() => {
        setValue("companyAdminList", companyAdminList);
    },[companyAdminList]);

    useEffect(() => {
        const subscription = watch((formValue) => {
            if (defaultData) {
                if (
                    defaultData.companyName != formValue.companyName
                    || JSON.stringify(defaultData.companyAdminList) != JSON.stringify(formValue.companyAdminList)
                    || defaultData.logoFile != formValue.logoFile
                ) {
                    setDirty(true);
                }
            }
        });
        return () => subscription.unsubscribe();
    },[watch, defaultData]);

    useEffect(() => {
        if (detailQuery.data) {
            setValue("logoFile", detailQuery.data.data.logoFilePath);
        }
    },[detailQuery.data]);

    useEffect(() => {
        if (detailQuery.isError) {
            if (detailQuery.error.response) {
                if (detailQuery.error.response.status == 403) {
                    navigate("/error/accessDenied");
                } else {
                    dispatch(showAlert({
                        msg: detailQuery.error.response.data.msg.ko,
                        func: () => {navigate(-1)}
                    }))
                }
            }
        }
    },[detailQuery.isError])

    if (detailQuery.isLoading) {
        return <Loading/>;
    }


    return (
        detailQuery.data &&
        <Wrap>
            <PageTemplate.Top>
                <div className="d-flex justify-content-between">
                    <div>
                        <BreadCrumb arr={[<Link to="/admin/list/company">관리자 설정</Link>, <Link to="/admin/list/company">업체 관리</Link>, <span className="fw-bold">업체 상세</span>]} />
                        <h1 className="page-title">업체 상세</h1>
                    </div>
                </div>
            </PageTemplate.Top>

            <PageTemplate.Content>
                <div>
                    <Card className="mt-4 overflow-hidden">
                        <Card.Header className="d-flex justify-content-between align-items-center">
                            <Card.Title className="d-flex align-items-center gap-2 fs-3 mb-0">
                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
                                    <path d="M4 2.5a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5zm3 0a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5zm3.5-.5a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5zM4 5.5a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5zM7.5 5a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5zm2.5.5a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5zM4.5 8a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5zm2.5.5a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5zm3.5-.5a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5z"/>
                                    <path d="M2 1a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1zm11 0H3v14h3v-2.5a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 .5.5V15h3z"/>
                                </svg>
                                업체 정보
                            </Card.Title>
                            <div className="small text-secondary">등록일시 | {detailQuery.data.data.registerTime}</div>
                        </Card.Header>

                        <Card.Body>
                            <Form.Group as={Row} className="mb-3" controlId="formCompanyName">
                                <Form.Label column sm="2">
                                    업체명 *
                                </Form.Label>
                                <Col sm="8">
                                    <InputGroupValidation 
                                        defaultValue={detailQuery.data.data.companyName}
                                        register={register("companyName", {
                                            required: "업체명을 입력해주세요",
                                        })} 
                                        invalid={errors['companyName']}
                                        placeholder="업체명을 입력하세요" 
                                        withoutSc={true}
                                    />
                                </Col>
                            </Form.Group>
                            <Form.Group as={Row} className="mb-3">
                                <Form.Label column sm="2">
                                    App ID *
                                </Form.Label>
                                <Col sm="8">
                                    <Form.Control defaultValue={detailQuery.data.data.appId} disabled /> 
                                </Col>
                            </Form.Group>
                            <Form.Group as={Row} className="mb-3">
                                <Form.Label column sm="2">
                                    Merchant ID *
                                </Form.Label>
                                <Col sm="8">
                                    <Form.Control defaultValue={detailQuery.data.data.merchantId} disabled /> 
                                </Col>
                            </Form.Group>
                            <Form.Group as={Row} className="mb-3" controlId="formName">
                                <Form.Label column sm="2">
                                    로고 이미지 *
                                </Form.Label>
                                <Col sm="8">
                                    <InputFilePreview 
                                        defaultValue={detailQuery.data.data.logoFilePath}
                                        register={register("logoFile")} invalid={errors['logoFile']} 
                                        accept="image/jpg, image/png, image/jpeg"
                                        max={2}
                                    />
                                </Col>
                            </Form.Group>
                        </Card.Body>
                    </Card>

                    <Card className="mt-4 overflow-hidden">
                        <Card.Header>
                            <Card.Title className="d-flex align-items-center gap-2 fs-3">
                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
                                <path d="M12.5 16a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7m.5-5v1h1a.5.5 0 0 1 0 1h-1v1a.5.5 0 0 1-1 0v-1h-1a.5.5 0 0 1 0-1h1v-1a.5.5 0 0 1 1 0m-2-6a3 3 0 1 1-6 0 3 3 0 0 1 6 0M8 7a2 2 0 1 0 0-4 2 2 0 0 0 0 4"/>
                                <path d="M8.256 14a4.5 4.5 0 0 1-.229-1.004H3c.001-.246.154-.986.832-1.664C4.484 10.68 5.711 10 8 10q.39 0 .74.025c.226-.341.496-.65.804-.918Q8.844 9.002 8 9c-5 0-6 3-6 4s1 1 1 1z"/>
                                </svg>
                                업체 관리자
                                <span className="ms-2 fs-6 fw-normal text-danger">* 최소 1개 이상의 계정은 필수로 등록해야합니다.</span>
                            </Card.Title>
                        </Card.Header>

                        <Card.Body>
                            <Form.Group as={Row} className="mb-3" controlId="formPhone">
                                <Form.Label column sm="2">
                                    휴대폰 번호(ID) *
                                </Form.Label>
                                <Col sm="8">
                                    <InputAddField 
                                        btnText="계정 추가" 
                                        defaultCreated={detailQuery.data.data.admin.length > 0 ? 0 : 1} 
                                        confirm={<>계정 삭제 시 관리자 접속이 불가합니다. <br/>정말 해당 계정을 삭제하시겠어요?</>}
                                        handleDelete={removeCompanyAdminList}
                                        template={<MobileAuth
                                                    type="2"
                                                    addedArr={companyAdminList}
                                                    addValue={addCompanyAdminList}
                                                    removeValue={removeCompanyAdminList}
                                                />} 
                                    >
                                        {
                                            detailQuery.data.data.admin.length > 0 && 
                                            detailQuery.data.data.admin.map((el) => {
                                                return (
                                                    <div val={el.phone} key={"admin_" + el.adminid}>
                                                        <div className="small text-secondary mt-2" >
                                                            최근 접속일시 | {el.lastLoginTime}
                                                        </div>
                                                    </div>
                                                )
                                            })
                                        }
                                    </InputAddField>
                                </Col>
                            </Form.Group>
                        </Card.Body>
                    </Card>

                    <Card className="mt-4 overflow-hidden">
                        <Card.Header className="d-flex align-items-center justify-content-between">
                            <Card.Title className="d-flex align-items-center gap-2 fs-3">
                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
                                <path d="M12.166 8.94c-.524 1.062-1.234 2.12-1.96 3.07A32 32 0 0 1 8 14.58a32 32 0 0 1-2.206-2.57c-.726-.95-1.436-2.008-1.96-3.07C3.304 7.867 3 6.862 3 6a5 5 0 0 1 10 0c0 .862-.305 1.867-.834 2.94M8 16s6-5.686 6-10A6 6 0 0 0 2 6c0 4.314 6 10 6 10"/>
                                <path d="M8 8a2 2 0 1 1 0-4 2 2 0 0 1 0 4m0 1a3 3 0 1 0 0-6 3 3 0 0 0 0 6"/>
                                </svg>
                                지점 리스트
                            </Card.Title>

                            <p className="m-0 small">
                                총 <span className="fw-bold">{branchList.length}</span>개
                            </p>
                        </Card.Header>

                        <Card.Body>
                            <DataTable data={{
                                head: ["No", "지역", "지점명", "대표자명", "전화번호", "등록일시"],
                                body: branchList,
                            }}></DataTable>
                        </Card.Body>
                    </Card>
                </div>
            </PageTemplate.Content>

            <PageTemplate.ButtonContainer className={loginInfo.admin.level == 1 && id != 1 ? "mt-3 justify-content-between" : "mt-3 justify-content-end"}>
                {
                    (loginInfo.admin.level == 1 && id != 1) &&
                    <Button variant="outline-danger" onClick={() => {
                        dispatch(showConfirm({
                            msg: <>업체 삭제 시 하위 지점 정보도 모두 삭제됩니다.<br/>정말 삭제하시겠어요?</>,
                            btnText: "삭제",
                            func: () => {
                                deleteCompany.mutate();
                                dispatch(hideConfirm());
                            }
                        }))
                    }}>삭제</Button>
                }
                <div>
                    <Button className="me-2" variant="outline-secondary" onClick={() => {
                        if (dirty) {
                            dispatch(showConfirm({
                                msg: <>수정 중인 내용이 저장되지 않았습니다.<br/>정말 나가시겠어요?</>,
                                btnText: "확인",
                                func: () => {
                                    navigate(-1);
                                    dispatch(hideConfirm());
                                }
                            }))
                        } else {
                            navigate(-1);
                        }
                    }}>취소</Button>
                    <Button variant="primary" onClick={handleSubmit(() => {
                        const logoFile = getValues().logoFile;
                        if (logoFile) {
                            if (logoFile.length == 0) {
                                setError("logoFile", {
                                    type: 'custom',
                                    message: "로고 이미지를 등록해주세요"
                                });
                            } else {
                                dispatch(showConfirm({
                                    msg: <>수정된 내용은 하위 지점에도 일괄 반영됩니다.<br/>정말 수정하시겠어요?</>,
                                    func: () => {
                                        updateCompany.mutate();
                                        dispatch(hideConfirm());
                                    }
                                }))
                            }
                        }
                    })}>수정</Button>
                </div>
            </PageTemplate.ButtonContainer>
        </Wrap>
    );
}
